import { render, staticRenderFns } from "./Pills.vue?vue&type=template&id=1f76c906&"
import script from "./Pills.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pills.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Pills.vue?vue&type=style&index=0&id=1f76c906&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports